import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import { Chip } from "@mui/material";
import { type MRT_ColumnDef } from "material-react-table";
import { useMemo } from "react";

import { EstadoLlamadaComponent } from "@/erp/operaciones/instalaciones/shared/components";
import {
  EncuestaPreagendaCell,
  EquipoAdicionalIconBtnCellModal,
} from "@/erp/operaciones/preagendamiento/shared/components";
import {
  EstadosPreagendamientoEnumChoice,
  RestaDeFechasDHM,
  TrazabilidadAccionChoiceEnum,
  // TipoEmpleadoEnumChoice,
  // TrazabilidadAccionChoiceEnum,
  calcColorStatePreAgenda,
  calcStateTextPreAgenda,
  cellLineaRazonSocial,
  cellNotFilter,
  dateCellValues,
  emptyCellOneLevel,
  fnTipoContrato,
  formatCurrency,
  formatDate,
  formatDateWithTimeCell,
  formatHourCellValue,
} from "@/shared";
import { EstadoComponente, SingleIconButton } from "@/shared/components/ui";
import { SingleImageAndBtnCellModal } from "@/shared/components/ui/Dialogs";
import {
  Agendamiento,
  EstadoPagoEnum,
  EstadosPreagendamientoCodigoEnum,
} from "@/shared/interfaces";
// import InfoUser from '@/shared/components/ui/InfoUser/InfoUser';
import ModalFotoContratoComponente from "@/erp/clientes/contrato/shared/modal-fotos-contrato-componentente/ModalFotosContratoComponente";
import InfoFormaPago from "@/erp/sale/asesor/pre_agendamiento/shared/componente/InfoFormaPago/InfoFormaPago";
import InfoObservaciones from "@/erp/sale/asesor/pre_agendamiento/shared/componente/InfoObservaciones/InfoObservaciones";
import InfoUser from "@/shared/components/ui/InfoUser/InfoUser";
import dayjs from "dayjs";

export const tipoContrato: { text: string; value: string }[] = [
  {
    value: "true",
    text: "CONTRATO FISICO",
  },
  {
    value: "false",
    text: "CONTRATO DIGITAL",
  },
];

export const useColumnsAgendamientos = () => {
  const agendamientoBaseColums = useMemo<MRT_ColumnDef<Agendamiento>[]>(
    () => [
      {
        accessorKey: "identificacion",
        header: "identificacion",
        size: 180,
        Cell: ({ row }) =>
          row.original?.prospecto_data?.identificacion || "N/A",
      },
      {
        accessorKey: "razon_social",
        header: "Nombre",
        size: 300,
        Cell: ({ row }) => row.original?.prospecto_data?.razon_social || "N/A",
      },
      {
        accessorKey: "numero_contrato",
        header: "Núm. Contrato",
        size: 240,
        Cell: ({ row }) =>
          row.original?.contrato_data?.numero_referencia || "N/A",
      },
      {
        accessorKey: "estado_pago",
        header: "estado pago",
        size: 150,
        enableColumnFilter: false,
        enableSorting: false,
        Cell: ({ row }) => {
          const isPendingVoucher =
            row.original?.preagendamiento_data?.estado_pago ===
            EstadoPagoEnum.VOUCHER_PENDIENTE;
          return (
            <EstadoComponente
              backgroundColor={isPendingVoucher ? "blue" : "green"}
              texto={row.original?.preagendamiento_data?.estado_pago || "N/A"}
            />
          );
        },
      },
      {
        accessorKey: "descripcion_pago",
        header: "Descripción de pago",
        size: 300,
        enableColumnFilter: false,
        enableSorting: false,
        Cell: ({ row }) => emptyCellOneLevel(row, "descripcion_pago"),
      },
      {
        accessorKey: "estado_llamada",
        header: "Estado de llamada",
        size: 300,
        enableColumnFilter: false,
        enableSorting: false,
        Cell: ({ row }) => {
          return row.original?.estado_llamada ? (
            <EstadoLlamadaComponent estado={row.original.estado_llamada} />
          ) : (
            "N/A"
          );
        },
      },
      {
        accessorKey: "observacion_llamada",
        header: "Observación de llamada",
        size: 300,
        enableColumnFilter: false,
        enableSorting: false,
        Cell: ({ row }) => {
          return row.original?.observaciones?.observacion_llamada || "N/A";
        },
      },
      {
        accessorKey: "fecha_hora_llamada",
        header: "FECHA HORA LLAMADA",
        size: 180,
        enableColumnFilter: true,
        enableSorting: true,
        Cell: ({ row }) => formatDateWithTimeCell(row, "fecha_hora_llamada"),
      },

      // -------------
      {
        accessorKey: "fecha_instalacion",
        header: "Fecha Instalación",
        size: 300,
        Cell: ({ row }) => dateCellValues(row, "fecha_instalacion"),
      },
      {
        accessorKey: "hora_instalacion",
        header: "Hora Instalación",
        size: 300,
        Cell: ({ row }) => formatHourCellValue(row, "hora_instalacion"),
      },
      {
        accessorKey: "direccion",
        header: "direccion",
        size: 300,
        Cell: ({ row }) => row.original?.preventa_data?.direccion || "N/A",
      },
      // {
      //   accessorKey: 'fecha_hora_instalacion',
      //   header: 'FECHA HORA INSTALACION',
      //   size: 210,
      //   enableColumnFilter: true,
      //   enableSorting: true,
      //   Cell: ({ row }) =>
      //     formatDateWithTimeCell(row, 'fecha_hora_instalacion'),
      // },

      //
      {
        accessorKey: "coordenadas",
        header: "COORDENADAS",
        size: 210,

        Cell: ({ row }) => emptyCellOneLevel(row, "coordenadas"),
      },
      {
        accessorKey: "celular",
        header: "CELULAR CLIENTE",
        size: 180,

        Cell: ({ row }) => row.original?.prospecto_data?.celular || "N/A",
      },
      {
        accessorKey: "celular_2",
        header: "CELULAR 2",
        size: 180,

        Cell: ({ row }) => row.original?.preventa_data?.celular_2 || "N/A",
      },
      {
        accessorKey: "email",
        header: "EMAIL",
        size: 180,
        Cell: ({ row }) => row.original?.preventa_data?.email || "N/A",
      },

      // Persona de referencia ------------------
      {
        accessorKey: "persona_referencia_nombre",
        header: "Persona de referencia",
        size: 210,
        Cell: ({ row }) =>
          row.original?.preventa_data?.persona_referencia_nombre || "N/A",
      },
      {
        accessorKey: "persona_referencia_celular",
        header: "Celular de referencia",
        size: 210,
        Cell: ({ row }) =>
          row.original?.preventa_data?.persona_referencia_celular || "N/A",
      },
      {
        accessorKey: "persona_referencia_celular_2",
        header: "Celular de referencia 2",
        size: 210,
        Cell: ({ row }) =>
          row.original?.preventa_data?.persona_referencia_celular_2 || "N/A",
      },
      {
        accessorKey: "persona_referencia_parentesco",
        header: "Parentesco de referencia",
        size: 210,
        Cell: ({ row }) =>
          row.original?.preventa_data?.persona_referencia_parentesco || "N/A",
      },

      ///* fk ========================================

      // // plan ------------------
      {
        accessorKey: "tipo_plan",
        header: "Tipo Plan",
        size: 210,
        Cell: ({ row }) => {
          return row.original?.preventa_data?.tipo_plan || "N/A";
        },
      },
      {
        accessorKey: "tipo_servicio",
        header: "Tipo de servicio",
        size: 210,
        Cell: ({ row }) => {
          return row.original?.preventa_data?.tipo_servicio || "N/A";
        },
      },
      {
        accessorKey: "plan",
        header: "Plan de internet",
        size: 210,
        Cell: ({ row }) => {
          return row.original?.plan_data?.nombre || "N/A";
        },
      },
      {
        accessorKey: "velocidad_internet",
        header: "Velocidad de internet",
        size: 210,
        Cell: ({ row }) => {
          return row.original?.plan_data?.velocidad_subida_maxima
            ? `${row.original?.plan_data?.velocidad_subida_minima} ${
                row.original?.plan_data?.unidad || ""
              }`
            : "N/A";
        },
      },
      {
        accessorKey: "valor_plan",
        header: "Valor del plan",
        size: 210,
        Cell: ({ row }) => {
          return row.original?.preventa_data?.valor_plan
            ? formatCurrency(row.original?.preventa_data?.valor_plan)
            : formatCurrency(0);
        },
      },

      // valor_instalacion ------------------
      {
        accessorKey: "valor_instalacion",
        header: "Valor Instalación",
        size: 210,
        Cell: ({ row }) => {
          return row.original?.preventa_data?.valor_instalacion
            ? formatCurrency(row.original?.preventa_data?.valor_instalacion)
            : formatCurrency(0);
        },
      },
      {
        accessorKey: "valor_instalacion_iva",
        header: "Valor IVA Instalación",
        size: 210,
        Cell: ({ row }) => {
          return row.original?.preventa_data?.valor_instalacion_iva
            ? formatCurrency(row.original?.preventa_data?.valor_instalacion_iva)
            : formatCurrency(0);
        },
      },
      {
        accessorKey: "valor_instalacion_total",
        header: "Valor Total Instalación",
        size: 210,
        Cell: ({ row }) => {
          return row.original?.preventa_data?.valor_instalacion_total
            ? formatCurrency(
                row.original?.preventa_data?.valor_instalacion_total
              )
            : formatCurrency(0);
        },
      },

      // flota & nap ------------------
      {
        accessorKey: "flota",
        header: "FLOTA",
        size: 180,
        Cell: ({ row }) => row.original?.flota_data?.nombre || "N/A",
      },
      {
        accessorKey: "nap_data_nombre",
        header: "NAP",
        size: 180,
        Cell: ({ row }) => row?.original?.nap_data_nombre || "N/A",
      },
      {
        accessorKey: "distancia",
        header: "DISTANCIA A LA NAP",
        size: 180,
        Cell: ({ row }) => emptyCellOneLevel(row, "distancia"),
      },

      {
        accessorKey: "contrato",
        header: "CONTRATO",
        size: 180,
        Cell: ({ row }) => {
          const url = row.original?.contrato_data?.url_contrato;
          if (!url) return "N/A";

          return (
            <SingleIconButton
              startIcon={<PictureAsPdfIcon />}
              label="Ver contrato"
              color="error"
              onClick={() => {
                window.open(url, "_blank");
              }}
            />
          );
        },
      },

      // encuesta y usos ------------------
      {
        accessorKey: "encuesta",
        header: "Encuesta",
        size: 81,
        Cell: ({ row }) => {
          return (
            <EncuestaPreagendaCell
              encuesta={row.original.preagendamiento_data?.encuesta!}
            />
          );
        },
      },

      // equipos_adicionales ------------------
      {
        accessorKey: "equipos_adicionales",
        header: "Equipos adicionales",
        size: 180,
        Cell: ({ row }) => (
          <EquipoAdicionalIconBtnCellModal
            equipoAdicional={row.original.preventa_data?.equipos_adicionales}
          />
        ),
      },

      // segmentacion ------------------
      {
        accessorKey: "segmentacion",
        header: "SEGMENTACIÓN",
        size: 180,
        Cell: ({ row }) => row.original?.prospecto_data?.segmentacion || "N/A",
      },
      {
        accessorKey: "puntaje_score",
        header: "PUNTAJE SCORE",
        size: 180,
        Cell: ({ row }) => row.original?.prospecto_data?.puntaje_score || "N/A",
      },
      {
        accessorKey: "puntaje_score_empresa",
        header: "PUNTAJE SCORE",
        size: 180,
        Cell: ({ row }) =>
          row.original?.prospecto_data?.puntaje_score_empresa || "N/A",
      },

      // //////////////////////////////////////////////
      // DOCS ------------------------
      {
        accessorKey: "url_foto_identificacion_delantera",
        header: "FOTO IDENTIFICACION DELANTERA",
        size: 180,
        enableColumnFilter: true,
        enableSorting: true,
        Cell: ({ row }) => {
          return (
            <SingleImageAndBtnCellModal
              url={row.original?.url_foto_identificacion_delantera}
              title="Foto de identificación delantera"
            />
          );
        },
      },
      {
        accessorKey: "url_foto_identificacion_posterior",
        header: "FOTO IDENTIFICACION POSTERIOR",
        size: 180,
        enableColumnFilter: true,
        enableSorting: true,
        Cell: ({ row }) => {
          return (
            <SingleImageAndBtnCellModal
              url={row.original?.url_foto_identificacion_posterior}
              title="Foto de identificación posterior"
            />
          );
        },
      },
      {
        accessorKey: "url_foto_aceptacion",
        header: "FOTO ACEPTACION CLIENTE",
        size: 180,
        enableColumnFilter: true,
        enableSorting: true,
        Cell: ({ row }) => {
          return (
            <SingleImageAndBtnCellModal
              url={row.original?.preventa_data?.url_foto_aceptacion!}
              title="Foto de Acetación Cliente"
            />
          );
        },
      },

      {
        accessorKey: "preventa_data.url_foto_cuenta_bancaria",
        header: "FOTO CUENTA BANCARIA",
        size: 180,
        enableColumnFilter: true,
        enableSorting: true,
        Cell: ({ row }) => {
          return (
            <SingleImageAndBtnCellModal
              url={row.original?.preventa_data?.url_foto_cuenta_bancaria!}
              title="Foto de la cuenta bancaria"
            />
          );
        },
      },
      {
        accessorKey: "preventa_data.url_foto_tarjeta",
        header: "FOTO TARJETA",
        size: 180,
        enableColumnFilter: true,
        enableSorting: true,
        Cell: ({ row }) => {
          return (
            <SingleImageAndBtnCellModal
              url={row.original?.preventa_data?.url_foto_tarjeta!}
              title="Foto de la tarjeta"
            />
          );
        },
      },
      {
        accessorKey: "url_foto_comprobante_v2",
        header: "FOTO COMPROBANTE PAGO",
        size: 180,
        enableColumnFilter: true,
        enableSorting: true,
        Cell: ({ row }) => {
          return (
            <SingleImageAndBtnCellModal
              url={row.original?.preagendamiento_data?.url_foto_comprobante!}
              title="Foto del comprobante de pago"
            />
          );
        },
      },
    ],
    []
  );

  const preagendamientoBaseColumnsEnd = useMemo<MRT_ColumnDef<Agendamiento>[]>(
    () => [
      ///* trazabilidad ------------------
      // {
      //   accessorKey: 'vendedor',
      //   header: 'VENDEDOR',
      //   size: 180,
      //   Cell: ({ row }) => row.original?.vendedor_data?.user || 'N/A',
      // },

      {
        accessorKey: "fecha_creacion",
        header: "Fecha Creación",
        size: 200,
        enableColumnFilter: true,
        filterVariant: "date",
        enableSorting: false,
        Cell: ({ row }) => formatDateWithTimeCell(row, "fecha_creacion"),
      },
      {
        accessorKey: "fecha_modificacion",
        header: "Fecha Modificación",
        size: 200,
        enableColumnFilter: true,
        filterVariant: "date",
        enableSorting: false,
        Cell: ({ row }) => formatDateWithTimeCell(row, "fecha_modificacion"),
      },
    ],
    []
  );

  const agendamientoColumnaBaseCambios = useMemo<MRT_ColumnDef<Agendamiento>[]>(
    () => [
      {
        accessorKey: "cliente_razon_social",
        header: "Cliente",
        size: 300,
        Cell: ({ row }) =>
          cellLineaRazonSocial(
            row.original.contrato_data,
            row.original.prospecto_data?.razon_social!
          ),
      },
      {
        accessorKey: "identificacion",
        header: "Identificación",
        size: 50,
        Cell: ({ row }) =>
          row.original?.prospecto_data?.identificacion || "N/A",
      },
      {
        accessorKey: "flota_nombre",
        header: "FLOTA",
        size: 180,
        Cell: ({ row }) => row.original?.flota_data?.nombre || "N/A",
      },
      {
        accessorKey: "fecha_instalacion",
        header: "Fecha instalación",
        size: 180,
      },
      {
        accessorKey: "hora_instalacion",
        header: "Hora instalación",
        size: 180,
      },
      {
        accessorKey: "coordenadas",
        header: "COORDENADAS",
        size: 180,

        Cell: ({ row }) => emptyCellOneLevel(row, "coordenadas"),
      },
      {
        accessorKey: "celular",
        header: "CELULAR CLIENTE",
        size: 180,

        Cell: ({ row }) => row.original?.prospecto_data?.celular || "N/A",
      },
      {
        accessorKey: "celular_2",
        header: "CELULAR 2",
        size: 180,

        Cell: ({ row }) => row.original?.preventa_data?.celular_2 || "N/A",
      },
      {
        accessorKey: "estado_agendamiento",
        header: "Estado PYL",
        enableColumnFilter: false,
        enableSorting: false,
        Cell: ({ row }) => (
          <EstadoComponente
            backgroundColor={calcColorStatePreAgenda(
              row.original
                ?.estado_agendamiento as EstadosPreagendamientoCodigoEnum
            )}
            texto={calcStateTextPreAgenda(
              row.original
                ?.estado_agendamiento as EstadosPreagendamientoEnumChoice
            )}
          />
        ),
      },
      {
        accessorKey: "estado_pago",
        header: "estado pago",
        size: 200,
        enableColumnFilter: false,
        enableSorting: false,
        Cell: ({ row }) => {
          const isPendingVoucher =
            row.original?.preagendamiento_data?.estado_pago ===
            EstadoPagoEnum.VOUCHER_PENDIENTE;
          return (
            <EstadoComponente
              backgroundColor={isPendingVoucher ? "blue" : "green"}
              texto={row.original?.preagendamiento_data?.estado_pago || "N/A"}
            />
          );
        },
      },
      {
        accessorKey: "fecha_aceptacion",
        header: "fecha de aceptación",
        size: 300,
        Cell: ({ row }) =>
          row.original?.preventa_data?.fecha_aceptacion
            ? dayjs(row.original?.preventa_data?.fecha_aceptacion).format(
                "L LT"
              )
            : "N/A",
      },
      {
        accessorKey: "ciudad_nombre",
        header: "Ciudad",
        size: 150,
        Cell: ({ row }) => row.original?.ciudad_data?.nombre || "N/A",
      },
      {
        accessorKey: "direccion",
        header: "direccion",
        size: 300,
        Cell: ({ row }) => row.original?.preventa_data?.direccion || "N/A",
      },
      {
        accessorKey: "nap_data_nombre",
        header: "NAP",
        Cell: ({ row }) => row.original?.nap_data_nombre || "N/A",
      },
      {
        accessorKey: "distancia",
        header: "DISTANCIA A LA NAP",
        size: 180,
        Cell: ({ row }) => emptyCellOneLevel(row, "distancia"),
      },

      {
        accessorKey: "contrato_numero",
        header: "Núm. Contrato",
        size: 240,
        Cell: ({ row }) =>
          row.original?.contrato_data?.numero_referencia || "N/A",
      },
      {
        accessorKey: "contrato_tipo_plan",
        header: "Tipo Plan",
        size: 210,
        Cell: ({ row }) => {
          return row.original?.preventa_data?.tipo_plan || "N/A";
        },
      },
      {
        accessorKey: "equipos_adicionales",
        header: "Equipos adicionales",
        size: 180,
        Cell: ({ row }) => (
          <EquipoAdicionalIconBtnCellModal
            equipoAdicional={row.original.preventa_data?.equipos_adicionales}
          />
        ),
      },
      {
        accessorKey: "valor_instalacion_total",
        header: "Valor Total Instalación",
        size: 210,
        Cell: ({ row }) => {
          return row.original?.preventa_data?.valor_instalacion_total
            ? formatCurrency(
                row.original?.preventa_data?.valor_instalacion_total
              )
            : formatCurrency(0);
        },
      },
      {
        accessorKey: "contrato_plan",
        header: "Plan de internet",
        size: 210,
        Cell: ({ row }) => {
          return row.original?.plan_data?.nombre || "N/A";
        },
      },
      {
        accessorKey: "tipo_servicio",
        header: "Tipo de servicio",
        size: 210,
        Cell: ({ row }) => {
          return row.original?.preventa_data?.tipo_servicio || "N/A";
        },
      },
      {
        accessorKey: "observaciones.observacion_llamada",
        header: "Observaciones",
        Cell: ({ row }) => (
          <InfoObservaciones
            label={"Observación de Llamada"}
            contentText={row.original?.observaciones?.observacion_llamada}
            fechaMod={
              row.original?.fecha_modificacion
                ? dayjs(row.original?.fecha_modificacion).format("LLL")
                : ""
            }
          />
        ),
      },
    ],
    []
  );

  const agendamientosAprobados = useMemo<MRT_ColumnDef<Agendamiento>[]>(
    () => [
      ...agendamientoColumnaBaseCambios,
      {
        accessorKey: "forma_pago_data.alias",
        header: "Forma de Pago",
        Cell: ({ row }) => (
          <InfoFormaPago
            preventa_data={row.original.preventa_data! as any}
            forma_pago_data={row.original.forma_pago_data}
            forma_pago_v2_data={(row.original as any).forma_pago_v2_data}
          />
        ),
      },
      ...preagendamientoBaseColumnsEnd,
      /* {
        accessorKey: 'tiempo_paso_preagendamiento_agendamiento',
        header: 'Retraso en Agendar',
        Cell: ({ row }) => RestaDeFechasDHM(
          row.original?.preventa_data?.fecha_aceptacion!,
          row.original?.fecha_modificacion!,
        )
      }, */
      {
        accessorKey: "tiempo_paso_preagendamiento_agendamiento",
        header: "Retraso en Agendar",
        Cell: ({ row }) =>
          RestaDeFechasDHM(
            row.original.trazo_venta_data?.find(
              (e) =>
                e.accion === TrazabilidadAccionChoiceEnum.CREACION &&
                e.preagendamiento
            )?.fecha_creacion!,
            row.original.trazo_venta_data?.find(
              (e) =>
                e.accion === TrazabilidadAccionChoiceEnum.AGENDAMIENTO &&
                e.agendamiento
            )?.fecha_creacion!
          ),
      },
    ],
    []
  );

  const agendamientosRecoordinados = useMemo<MRT_ColumnDef<Agendamiento>[]>(
    () => [
      ...agendamientoColumnaBaseCambios,
      ...preagendamientoBaseColumnsEnd,
      /* ...agendamientoBaseColums,
       ...preagendamientoBaseColumnsEnd */
    ],
    []
  );

  // Columnas para los tabs de TRASLADOS (Rechazados/Recoordinados). Idénticas a
  // las de recoordinación pero con un chip "TRASLADO" al inicio para etiquetar y
  // diferenciar de instalaciones. NO se toca agendamientosRecoordinados.
  const agendamientosTraslados = useMemo<MRT_ColumnDef<Agendamiento>[]>(
    () => [
      {
        accessorKey: "tipo_orden_servicio",
        header: "Tipo",
        size: 120,
        Cell: () => (
          <Chip size="small" color="primary" variant="outlined" label="TRASLADO" />
        ),
      },
      ...agendamientosRecoordinados,
    ],
    [agendamientosRecoordinados]
  );

  const agendamientoColumnaVentas = useMemo<MRT_ColumnDef<Agendamiento>[]>(
    () => [
      {
        accessorKey: "cliente_razon_social",
        header: "Cliente",
        size: 300,
        Cell: ({ row }) =>
          cellLineaRazonSocial(
            row.original.contrato_data,
            row.original.prospecto_data?.razon_social!
          ),
      },
      {
        accessorKey: "identificacion",
        header: "Identificación",
        Cell: ({ row }) =>
          row.original?.prospecto_data?.identificacion || "N/A",
      },
      {
        accessorKey: "requiere_contrato_fisico",
        header: "Tipo de Contrato",
        size: 250,
        filterVariant: "select",
        filterSelectOptions: tipoContrato,
        muiTableHeadCellFilterTextFieldProps: {
          select: true,
        },
        Cell: ({ row }) => (
          <EstadoComponente
            backgroundColor={
              fnTipoContrato(
                row.original.preventa_data!.pre_requiere_contrato_fisico,
                row.original.preventa_data!.requiere_contrato_fisico
              ).color
            }
            texto={
              fnTipoContrato(
                row.original.preventa_data!.pre_requiere_contrato_fisico,
                row.original.preventa_data!.requiere_contrato_fisico
              ).texto
            }
          />
        ),
      },

      {
        accessorKey: "contrato_tipo_plan",
        header: "Tipo Plan",
        size: 180,
        Cell: ({ row }) => row.original?.contrato_data?.tipo_plan || "N/A",
      },
      {
        accessorKey: "contrato_plan",
        header: "Plan de internet",
        size: 210,
        Cell: ({ row }) => {
          return row.original?.plan_data?.nombre || "N/A";
        },
      },
      {
        accessorKey: "ciudad_nombre",
        header: "Ciudad",
        size: 150,
        Cell: ({ row }) => row.original?.ciudad_data?.nombre || "N/A",
      },
      // {
      //   accessorKey: "flota_nombre",
      //   header: "flota",
      //   Cell: ({ row }) => row.original?.flota_data?.nombre || "N/A",
      // },
      {
        ...cellNotFilter,
        accessorKey: "tipo_servicio",
        header: "Tipo de servicio",
        size: 210,
        Cell: ({ row }) => {
          return row.original?.preventa_data?.tipo_servicio || "N/A";
        },
      },
      {
        ...cellNotFilter,
        accessorKey: "fecha_instalacion",
        header: "Fecha instalación",
        size: 180,
      },
      {
        ...cellNotFilter,
        accessorKey: "hora_instalacion",
        header: "Hora instalación",
        size: 180,
      },
      {
        ...cellNotFilter,
        accessorKey: "preventa_data",
        header: "Imagenes",
        Cell: ({ row }) =>
          row.original.preventa_data != null ? (
            <ModalFotoContratoComponente
              preventa_data={row.original.preventa_data! as any}
            />
          ) : (
            "N/A"
          ),
      },
      {
        ...cellNotFilter,
        accessorKey: "coordenadas",
        header: "COORDENADAS",
        size: 180,
        Cell: ({ row }) => emptyCellOneLevel(row, "coordenadas"),
      },
      {
        ...cellNotFilter,
        accessorKey: "celular",
        header: "CELULAR CLIENTE",
        size: 180,

        Cell: ({ row }) => row.original?.prospecto_data?.celular || "N/A",
      },
      {
        ...cellNotFilter,
        accessorKey: "celular_2",
        header: "CELULAR 2",
        size: 180,
        Cell: ({ row }) => row.original?.preventa_data?.celular_2 || "N/A",
      },
      {
        ...cellNotFilter,
        accessorKey: "estado_agendamiento",
        header: "Estado PyL",
        enableColumnFilter: false,
        enableSorting: false,
        Cell: ({ row }) => (
          <EstadoComponente
            backgroundColor={calcColorStatePreAgenda(
              row.original
                ?.estado_agendamiento as EstadosPreagendamientoCodigoEnum
            )}
            texto={calcStateTextPreAgenda(
              row.original
                ?.estado_agendamiento as EstadosPreagendamientoEnumChoice
            )}
          />
        ),
      },
      {
        ...cellNotFilter,
        accessorKey: "direccion",
        header: "direccion",
        size: 300,
        Cell: ({ row }) => row.original?.preventa_data?.direccion || "N/A",
      },
      {
        ...cellNotFilter,
        accessorKey: "nap_data_nombre",
        header: "NAP",
        Cell: ({ row }) => row.original?.nap_data_nombre || "N/A",
      },
      {
        ...cellNotFilter,
        accessorKey: "distancia",
        header: "DISTANCIA A LA NAP",
        size: 180,
        Cell: ({ row }) => emptyCellOneLevel(row, "distancia"),
      },
      {
        ...cellNotFilter,
        accessorKey: "equipos_adicionales",
        header: "Equipos adicionales",
        size: 180,
        Cell: ({ row }) => (
          <EquipoAdicionalIconBtnCellModal
            equipoAdicional={row.original.preventa_data?.equipos_adicionales}
          />
        ),
      },
      {
        ...cellNotFilter,
        accessorKey: "valor_instalacion_total",
        header: "Valor Total Instalación",
        size: 210,
        Cell: ({ row }) => {
          return row.original?.preventa_data?.valor_instalacion_total
            ? formatCurrency(
                row.original?.preventa_data?.valor_instalacion_total
              )
            : formatCurrency(0);
        },
      },

      {
        // ...cellNotFilter,
        accessorKey: "canal_venta_create",
        header: "Canal de Venta",
        size: 200,
      },
      {
        accessorKey: "observaciones.observacion_llamada",
        header: "Observación PyL",
        Cell: ({ row }) => (
          <InfoObservaciones
            label={"Observación de Llamada"}
            contentText={row.original?.observaciones?.observacion_llamada}
            fechaMod={
              row.original?.fecha_modificacion
                ? dayjs(row.original?.fecha_modificacion).format("LLL")
                : ""
            }
          />
        ),
      },
      {
        ...cellNotFilter,
        accessorKey: "forma_pago_data.alias",
        header: "Forma de Pago",
        Cell: ({ row }) => (
          <InfoFormaPago
            preventa_data={row.original.preventa_data! as any}
            forma_pago_data={row.original.forma_pago_data}
            forma_pago_v2_data={(row.original as any).forma_pago_v2_data}
          />
        ),
      },
      {
        accessorKey: "user_create",
        header: "VENDEDOR",
        size: 180,
        Cell: ({ row }) => (
          <InfoUser user={row.original.user_create ?? "N/A"} />
        ),
      },

      {
        accessorKey: "fecha_creacion",
        header: "Fecha creacion",
        size: 180,
        Cell: ({ row }) => <>{formatDate(row.original.fecha_creacion!)}</>,
      },
    ],
    []
  );


  const agendamientosSeguimientoPyL = useMemo<MRT_ColumnDef<Agendamiento|any>[]>(
    () => [
      {
        accessorKey: "fecha_actividad",
        header: "Fecha Actividad",
        Cell: ({ row }) => (
          <>{row.original.fecha && row.original.hora_inicio? 
            `${formatDate(row.original.fecha)} ${row.original.hora_inicio}`:
            "N/A"}</>
        ),
        enableColumnFilter: false,
        enableSorting: false,
      },
      {
        accessorKey: "ingreso_salida_tecnico",
        header: "Ingreso/Salida Técnico",
        Cell: ({ row }) => (
          <>{row.original?.ingreso_pyl?`De ${row.original.ingreso_pyl}  ${row.original.salida_pyl ? "a "+row.original.salida_pyl : "(Salida no registrada aún)"}` : "N/A"}</>
        ),
        enableColumnFilter: false,
        enableSorting: false,
      },
      {
        accessorKey: "tipo_actividad",
        header: "Tipo de Actividad",
        Cell: ({ row }) => (
          <>{row.original?.tipo_actividad? (row.original.tipo_actividad).toUpperCase() : "N/A"}</>
        ),
        enableColumnFilter: false,
        enableSorting: false,
      },
      {
        accessorKey: "nombre_tecnico",
        header: "Técnico",
        Cell: ({ row }) => (
          <>{row.original?.nombre_tecnico || "N/A"}</>
        ),
        enableColumnFilter: false,
        enableSorting: false,
      },
      {
        accessorKey: "activacion",
        header: "Datos Activaciones",
        Cell: ({ row }) => (
          <>{row.original?.activacion? (row.original.activacion).toUpperCase() : "PENDIENTE ACTIVAR"}</>
        ),
        enableColumnFilter: false,
        enableSorting: false,
      },
      {
        accessorKey: "estado_tecnico",
        header: "Estado Informe",
        Cell: ({ row }) => (
          <>{row.original?.estado_tecnico? (row.original.estado_tecnico).toUpperCase() : "PENDIENTE"}</>
        ),
        enableColumnFilter: false,
        enableSorting: false,
      },
      {
        accessorKey: "vendedor",
        header: "Vendedor",
        Cell: ({ row }) => (
          <>{row.original?.vendedor? (row.original.vendedor).toUpperCase() : "N/A"}</>
        ),
        enableColumnFilter: false,
        enableSorting: false,
      },
      {
        accessorKey: "cargo",
        header: "Departamento",
        Cell: ({ row }) => (
          <>{row.original?.cargo? (row.original.cargo).toUpperCase() : "N/A"}</>
        ),
        enableColumnFilter: false,
        enableSorting: false,
      },
      {
        accessorKey: "nombre_plan",
        header: "Nombre Plan",
        Cell: ({ row }) => (
          <>{row.original?.nombre_plan || "N/A"}</>
        ),
        enableColumnFilter: false,
        enableSorting: false,
      },
      {
        accessorKey: "cedula_identidad",
        header: "CI/RUC",
        Cell: ({ row }) => (
          <>{row.original?.cedula_identidad || "N/A"}</>
        ),
        enableColumnFilter: false,
        enableSorting: false,
      },
      {
        accessorKey: "nombre_cliente",
        header: "Nombre Cliente",
        Cell: ({ row }) => (
          <>{row.original?.nombre_cliente || "N/A"}</>
        ),
        enableColumnFilter: false,
        enableSorting: false,
      },
      {
        accessorKey: "ciudad",
        header: "Ciudad",
        Cell: ({ row }) => (
          <>{(row.original?.ciudad)?.toUpperCase() || "N/A"}</>
        ),
        enableColumnFilter: false,
        enableSorting: false,
      },
      {
        accessorKey: "sector",
        header: "Sector",
        Cell: ({ row }) => (
          <>{row.original?.sector || "N/A"}</>
        ),
        enableColumnFilter: false,
        enableSorting: false,
      },
      {
        accessorKey: "zona",
        header: "Zona",
        Cell: ({ row }) => (
          <>{row.original?.zona || "N/A"}</>
        ),
        enableColumnFilter: false,
        enableSorting: false,
      },
      {
        accessorKey: "coordenadas",
        header: "Coordenadas",
        Cell: ({ row }) => (
          <>{row.original?.coordenadas || "N/A"}</>
        ),
        enableColumnFilter: false,
        enableSorting: false,
      },
      {
        accessorKey: "telefono_movil",
        header: "Teléfonos",
        Cell: ({ row }) => (
          <>{row.original?.telefono_movil + " - " + row.original?.telefono_fijo + " - " + row.original?.telefono_adicional|| "N/A"}</>
        ),
        enableColumnFilter: false,
        enableSorting: false,
      },
      {
        accessorKey: "detalle_informe",
        header: "Observaciones",
        Cell: ({ row }) => (
          <>{row.original?.detalle_informe || "N/A"}</>
        ),
        enableColumnFilter: false,
        enableSorting: false,
      },
    ],
    []
  );


  const agendamientosSeguimientoSupVentas = useMemo<MRT_ColumnDef<Agendamiento|any>[]>(
    () => [
      {
        accessorKey: "fecha_actividad",
        header: "Fecha Actividad",
        Cell: ({ row }) => (
          <>{row.original.fecha && row.original.hora_inicio? 
            `${formatDate(row.original.fecha)} ${row.original.hora_inicio}`:
            "N/A"}</>
        ),
        enableColumnFilter: false,
        enableSorting: false,
      },
      {
        accessorKey: "ingreso_salida_tecnico",
        header: "Ingreso/Salida Técnico",
        Cell: ({ row }) => (
          <>{row.original?.ingreso_pyl?`De ${row.original.ingreso_pyl}  ${row.original.salida_pyl ? "a "+row.original.salida_pyl : "(Salida no registrada aún)"}` : "N/A"}</>
        ),
        enableColumnFilter: false,
        enableSorting: false,
      },
      {
        accessorKey: "tipo_actividad",
        header: "Tipo de Actividad",
        Cell: ({ row }) => (
          <>{row.original?.tipo_actividad? (row.original.tipo_actividad).toUpperCase() : "N/A"}</>
        ),
        enableColumnFilter: false,
        enableSorting: false,
      },
      {
        accessorKey: "activacion",
        header: "Datos Activaciones",
        Cell: ({ row }) => (
          <>{row.original?.activacion? (row.original.activacion).toUpperCase() : "PENDIENTE ACTIVAR"}</>
        ),
        enableColumnFilter: false,
        enableSorting: false,
      },
      {
        accessorKey: "estado_tecnico",
        header: "Estado Informe",
        Cell: ({ row }) => (
          <>{row.original?.estado_tecnico? (row.original.estado_tecnico).toUpperCase() : "PENDIENTE"}</>
        ),
        enableColumnFilter: false,
        enableSorting: false,
      },
      {
        accessorKey: "vendedor",
        header: "Vendedor",
        Cell: ({ row }) => (
          <>{row.original?.vendedor? (row.original.vendedor).toUpperCase() : "N/A"}</>
        ),
        enableColumnFilter: false,
        enableSorting: false,
      },
      {
        accessorKey: "cargo",
        header: "Departamento",
        Cell: ({ row }) => (
          <>{row.original?.cargo? (row.original.cargo).toUpperCase() : "N/A"}</>
        ),
        enableColumnFilter: false,
        enableSorting: false,
      },
      {
        accessorKey: "nombre_plan",
        header: "Nombre Plan",
        Cell: ({ row }) => (
          <>{row.original?.nombre_plan || "N/A"}</>
        ),
        enableColumnFilter: false,
        enableSorting: false,
      },
      {
        accessorKey: "cedula_identidad",
        header: "CI/RUC",
        Cell: ({ row }) => (
          <>{row.original?.cedula_identidad || "N/A"}</>
        ),
        enableColumnFilter: false,
        enableSorting: false,
      },
      {
        accessorKey: "nombre_cliente",
        header: "Nombre Cliente",
        Cell: ({ row }) => (
          <>{row.original?.nombre_cliente || "N/A"}</>
        ),
        enableColumnFilter: false,
        enableSorting: false,
      },
      {
        accessorKey: "ciudad",
        header: "Ciudad",
        Cell: ({ row }) => (
          <>{(row.original?.ciudad)?.toUpperCase() || "N/A"}</>
        ),
        enableColumnFilter: false,
        enableSorting: false,
      },
      {
        accessorKey: "sector",
        header: "Sector",
        Cell: ({ row }) => (
          <>{row.original?.sector || "N/A"}</>
        ),
        enableColumnFilter: false,
        enableSorting: false,
      },
      {
        accessorKey: "zona",
        header: "Zona",
        Cell: ({ row }) => (
          <>{row.original?.zona || "N/A"}</>
        ),
        enableColumnFilter: false,
        enableSorting: false,
      },
      {
        accessorKey: "coordenadas",
        header: "Coordenadas",
        Cell: ({ row }) => (
          <>{row.original?.coordenadas || "N/A"}</>
        ),
        enableColumnFilter: false,
        enableSorting: false,
      },
      {
        accessorKey: "telefono_movil",
        header: "Teléfonos",
        Cell: ({ row }) => (
          <>{row.original?.telefono_movil + " - " + row.original?.telefono_fijo + " - " + row.original?.telefono_adicional|| "N/A"}</>
        ),
        enableColumnFilter: false,
        enableSorting: false,
      },
      {
        accessorKey: "detalle_informe",
        header: "Observaciones",
        Cell: ({ row }) => (
          <>{row.original?.detalle_informe || "N/A"}</>
        ),
        enableColumnFilter: false,
        enableSorting: false,
      },
    ],
    []
  );

  return {
    agendamientoBaseColums,
    preagendamientoBaseColumnsEnd,
    agendamientoColumnaVentas,

    agendamientosAprobados,
    agendamientosRecoordinados,
    agendamientosTraslados,
    agendamientosSeguimientoPyL,
    agendamientosSeguimientoSupVentas
  };
};
